import { createApiRequest } from "../common";
import { ResendOrgInviteRequestContent, ResendOrgInviteResponseContent } from '@equaliq/api-model';

export const resendOrgInviteApi = async (request: ResendOrgInviteRequestContent): Promise<ResendOrgInviteResponseContent> => {
  const apiRequest = createApiRequest<ResendOrgInviteResponseContent>('post', '/orgs/invites/resend');
  return apiRequest(request);
};
